import { IconsProps } from '@/types/shared'
import React from 'react'

const TimelineIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="0 0 24 24"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
            >
                {/* Timeline bars representing Gantt-style view */}
                <rect x="3" y="4" width="10" height="3" rx="1" />
                <rect x="8" y="10" width="12" height="3" rx="1" />
                <rect x="5" y="16" width="8" height="3" rx="1" />
            </svg>
        </div>
    )
}

export default TimelineIcons
